/*
 * Pricing Table "Choose Plan" -> add to cart interceptor.
 *
 * Converts any <a class="pricing-table__button"> whose href points at a
 * /products/HANDLE page into an AJAX add-to-cart call. Uses the product's
 * first available variant (Shopify products always have >=1 variant).
 *
 * Hydrates <cart-drawer>/<cart-notification> via its native renderContents()
 * so the flow matches the standard product-form.js add-to-cart behavior,
 * including pubsub and custom events other components listen to.
 *
 * Opt out per-button with data-add-to-cart="false".
 */
(function () {
  'use strict';

  var PRODUCT_CACHE = {};
  var CART_ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add';

  function getProductHandle(href) {
    if (!href) return null;
    try {
      var url = new URL(href, window.location.origin);
      var m = url.pathname.match(/\/products\/([^\/\?#]+)/);
      return m ? m[1] : null;
    } catch (_e) {
      return null;
    }
  }

  function fetchProduct(handle) {
    if (PRODUCT_CACHE[handle]) return Promise.resolve(PRODUCT_CACHE[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Product fetch failed: ' + r.status);
        return r.json();
      })
      .then(function (p) { PRODUCT_CACHE[handle] = p; return p; });
  }

  function pickVariantId(product) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;
    var available = product.variants.find(function (v) { return v.available; });
    return (available || product.variants[0]).id;
  }

  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function addToCart(variantId, cart) {
    var body = new FormData();
    body.append('id', String(variantId));
    body.append('quantity', '1');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      body.append('sections_url', window.location.pathname);
    }

    return fetch(CART_ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body,
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw data;
        return data;
      });
    });
  }

  function announceCartUpdate(variantId) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pricing-table', productVariantId: String(variantId) });
      }
    } catch (_e) {}
    try {
      document.dispatchEvent(new CustomEvent('variant:add', {
        detail: { variant: { id: variantId }, quantity: 1, sectionId: 'pricing-table' }
      }));
    } catch (_e) {}
  }

  function setButtonState(btn, state) {
    if (!btn) return;
    if (state === 'loading') {
      if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.setAttribute('aria-busy', 'true');
      btn.style.pointerEvents = 'none';
    } else {
      btn.removeAttribute('aria-busy');
      btn.style.pointerEvents = '';
      if (btn.dataset.originalText) {
        btn.textContent = btn.dataset.originalText;
        delete btn.dataset.originalText;
      }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('a.pricing-table__button');
    if (!btn) return;
    if (btn.dataset.addToCart === 'false') return;
    var handle = getProductHandle(btn.getAttribute('href'));
    if (!handle) return;

    e.preventDefault();
    setButtonState(btn, 'loading');
    var cart = getCartElement();
    if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

    var variantId;
    fetchProduct(handle)
      .then(function (product) {
        variantId = pickVariantId(product);
        if (!variantId) throw new Error('No variant available for ' + handle);
        return addToCart(variantId, cart);
      })
      .then(function (response) {
        announceCartUpdate(variantId);
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        console.error('[pricing-table-add-to-cart]', err);
        window.location.href = '/products/' + handle;
      })
      .then(function () { setButtonState(btn, 'idle'); });
  });
})();
